import React from "react";

import { Card, CardContent, Typography, Box } from "@material-ui/core";

export default function FormSection({
  title,
  children,
  icon,
  color = "#2979ff",
}) {
  return (
    <Card
      elevation={0}
      style={{
        marginBottom: 20,
        borderRadius: 16,
        border: "1px solid #EEF2F7",
        overflow: "hidden",
      }}
    >
      {/* Header Section */}
      <Box
        display="flex"
        alignItems="center"
        style={{
          padding: "14px 16px",
          background: "#FAFBFF",
          borderBottom: "1px solid #EEF2F7",
        }}
      >
        {/* Icon Box */}
        {icon && (
          <Box
            width={38}
            height={38}
            borderRadius="12px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{
              background: `${color}15`,
              color: color,
              marginLeft: 10,
            }}
          >
            {icon}
          </Box>
        )}

        {/* Title */}
        <Typography
          variant="h6"
          style={{
            fontWeight: 700,
            fontSize: 15,
            color: "#1F2937",
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Content */}
      <CardContent
        style={{
          padding: 18,
          background: "#FFFFFF",
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
}
